// extracted by mini-css-extract-plugin
export var orderDetails = "_uk-2";
export var orderImage = "_uk-1";
export var orderMeta = "_uk-3";
export var orderSummary = "_uk-0";
export var rightArrow = "_uk-4";